import {HTTP} from '@/CallAPI'

function getPermission () {
  return HTTP.get('/permissions?per_page=all')
}

function createPerm (permission) {
  return HTTP.post('/permissions', permission)
}

function showPermission (permission) {
  return HTTP.get('/permissions/' + permission.id)
}

function updatePermission (permission) {
  return HTTP.put('/permissions/' + permission.id, permission)
}

function destroyPermission (permission) {
  return HTTP.delete('/permissions/' + permission.id)
}

export default {
  getPermission,
  showPermission,
  createPerm,
  updatePermission,
  destroyPermission
}



// WEBPACK FOOTER //
// ./src/service/permission.js